import React from 'react';
import PropTypes from 'prop-types';
import ItemCompletionDialog from '@components/ItemCompletionDialog';
import { usePickListCompletionDialogActionHandler } from '@hooks/ui/usePickListCompletionDialogActionHandler';

/**
 * Dialog shown when the last pick on a Pick List row completes its parent
 * user set (a SET build or a minifigure collection). Mounted globally in
 * MainLayout so it fires from both the Pick List page and the pick list
 * embedded in the User Set Details dialog.
 *
 * @component
 */
const PickListCompletionDialog = ({ isOpen }) => {
    const { handleClose, handleApply, title, message, trackedInUserSets } = usePickListCompletionDialogActionHandler();

    return (
        <ItemCompletionDialog
            isOpen={isOpen}
            title={title}
            message={message}
            trackedInUserSets={trackedInUserSets}
            onClose={handleClose}
            onApply={handleApply}
            testId="pick-list-completion-dialog"
            trackedSetTestIdPrefix="pick-list-completion-tracked-set"
        />
    );
};

PickListCompletionDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired
};

export default PickListCompletionDialog;
